import React from 'react';

const Israel = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" fill="white" />
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 14.6665H28V17.3332H0V14.6665ZM0 2.6665H28V5.33317H0V2.6665ZM13.1667 11.9998H10.6667L11.9173 9.99984L10.6667 7.99984H13.1667L14 6.6665L14.8333 7.99984H17.3333L16.0827 9.99984L17.3333 11.9998H14.8333L14 13.3332L13.1667 11.9998ZM12.6667 9.99984L14 8.6665L15.3333 9.99984L14 11.3332L12.6667 9.99984Z"
      fill="#1A47B8"
    />
  </svg>
);

export default Israel;
